<script>
import { applicationUserManager } from '../applicationUserManager'
export default {
	name: 'callback',
	data() {
		return {}
	},
	created() {
		applicationUserManager.signinRedirectCallback().then(user =>{
			// succes, set user and go to app
			this.$store.commit('updateUser', user)
			window.location = '/'
		}).catch(async err =>{
			// error, try again
			await applicationUserManager.login()
		})
	}
}
</script>

<style>
</style>
